import React, { useState, useEffect, useMemo, useRef } from "react";
import { PortalDialog } from "Components/CommonComponents";
import { IconButton } from "@material-ui/core";
import { Close } from '@mui/icons-material';
import { Elements } from "@stripe/react-stripe-js";
import { CheckoutForm2 } from "./components/stripe";
import "./homagewallet.css";
import Api from "Api";
import {
  API_ADD_CARD,
  API_WALLET_PACKAGES,
  UNDEF,
} from "Constants";
import { stripePromise } from "./IPCAScheduling";
import { Div, Img, Txt } from "Components/GenericView";
import Transactions from "./components/transactions";
import ChargeDetails from "./components/chargeDetails";
import ChargeItem from "./components/chargeItem";
import ManagePackages from "./components/ManagePackages";
import PackageDetail from "./components/PackageDetail";
import PackageTransactions from "./components/PackageTransactions";

interface IWalletProps {
  coId: string;
  onCloseDialog: () => void;
  onCardAdded: () => void;
  setShowWallet: any;

  wallet: any;
  anchor: any;
  completed_charges: any;
  upcoming_charges: any;
  teleconsult_charges: any;
  isShowTransactions?: boolean;
  align: "left" | "right";
}

const Wallet: React.FC<IWalletProps> = ({
  onCloseDialog,
  onCardAdded,
  wallet,
  anchor,
  coId,
  align,
  completed_charges,
  upcoming_charges,
  teleconsult_charges,
  isShowTransactions,
}) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [showChargeDetails, setShowChargeDetails] = useState(null);
  const [showCompletedCharges, setShowCompletedCharges] = useState(false);
  const [isShowPackages, setShowPackages] = useState(false);
  const [packageDetail, setPackageDetail] = useState<any>(null);
  const [packageId, setPackageId] = useState(null);
  const [showTeleconsultCharges, setShowTeleconsultCharges] = useState(false);
  const [showIncompleteCharges, setShowIncompleteCharges] = useState(false);
  const [addCard, setAddCard] = useState(false);
  const [walletPackages, setWalletPackages] = useState(null);
  const [cardInfo, setCardInfo] = useState({
    number: "",
    icon: "",
  });
  const getChargeDataKeys = (chargeData: any) => {
    let chargeDateKeys = chargeData?.map((ele: any) => ele.charge_date);
    //@ts-ignore
    chargeDateKeys = [...new Set(chargeDateKeys)];
    chargeDateKeys = chargeDateKeys.sort(
      (a: any, b: any) => new Date(b).getTime() - new Date(a).getTime()
    );
    return chargeDateKeys;
  };
  const completeChargeDataKeys = getChargeDataKeys(completed_charges);
  const upcomingChargeDataKeys = getChargeDataKeys(upcoming_charges);
  const teleconsultChargeDataKeys = getChargeDataKeys(teleconsult_charges);
  const isConcierge = wallet && wallet.is_concierge;
  const popupStyle = useMemo(() => {
    const anchorElem = anchor || {};
    const alignLeft = align === "left";

    const s = {
      width: 422,
      padding: 0,
      position: "absolute",
      top: anchorElem.y,
      left: alignLeft ? anchorElem.x : UNDEF,
      right: !alignLeft ? anchorElem.x : UNDEF,
      opacity: anchorElem.y !== UNDEF ? 1 : 0,
      animationName: anchorElem.y ? "anim-popin" : "",
      animationDuration: "0.2s",
      transformOrigin: alignLeft ? "30% 0" : "70% 0",
      boxShadow: "0 2px 20px 0 rgba(0, 0, 0, 0.18)",
    };
    return s;
  }, [anchor, align]);

  useEffect(() => {
    if (wallet && wallet.card && wallet.card.end_with) {
      setCardInfo({
        number: wallet.card.end_with,
        icon: wallet.card.card_icon,
      });
    }
  }, [wallet]);
  const AddCardApi = (res: any) => {
    const req = {
      co_id: coId,
      stripe_token: res.token.id,
    };
    Api.POST(
      API_ADD_CARD,
      req,
      (resp?: any) => {
        if (resp && resp.data && resp.data.success) {
          onCardAdded();
          onCloseDialog();
        }
      },
      rootRef.current || true,
      true
    );
  };
  const backClick = () => {
    if (showChargeDetails) setShowChargeDetails(null);
    else if (!!packageId) setPackageId(null);
    else if (!!packageDetail) setPackageDetail(null);
    else {
      setShowCompletedCharges(false);
      setShowIncompleteCharges(false);
      setShowTeleconsultCharges(false);
      setShowPackages(false);
      setPackageDetail(null);
      setPackageId(null);
    }
  };
  const getSectionedData = (data: any) => {
    let transactionalArray: any[] = [];
    data.forEach((item: any) => {
      const existingVisit = transactionalArray.find(
        (ele) =>
          item.visit_id &&
          item.type === "visit" && // group only visits nothing else
          !item.is_cancelled && // eliminate cancelled from grouping
          ele.visit_id === item.visit_id &&
          ele.charge_date === item.charge_date
      );
      if (existingVisit) {
        existingVisit.items = [...existingVisit.items, item];
      } else {
        transactionalArray.push({
          items: [item],
          visit_id: item.visit_id,
          charge_date: item.charge_date,
        });
      }
    });
    return transactionalArray;
  };
  const handleManagePackage = () => {
    Api.GET(
      API_WALLET_PACKAGES + coId,
      (resp?: any) => {
        setWalletPackages(resp?.data?.data);
      },
      true,
      true
    );
    setShowPackages(true);
  };
  const cardNumber = cardInfo.number;
  return (
    <PortalDialog
      style={popupStyle}
      hideOverlay
      className="ha-dialog"
      result={onCloseDialog}
    >
      <div className="v" ref={rootRef}>
        <div className="wa-m-16 wa-dialog-close-container flex center space-between">
          <div className="h vc m-l-16">
            {showChargeDetails ||
              showCompletedCharges ||
              showTeleconsultCharges ||
              showIncompleteCharges ||
              !!packageDetail ||
              !!packageId ||
              isShowPackages ? (
              <span
                className="flex justify-center center mr-3 pointer"
                onClick={backClick}
              >
                <img alt="" width={16} src="/self-serve/back@3x.png" />
              </span>
            ) : (
              <span className="wa-img">
                <img
                  alt=""
                  width={20}
                  height={15}
                  src="/self-serve/wallet@3x.png"
                />
              </span>
            )}
            {!!!packageDetail || !!packageId ? (
              <span className="wa-title">
                {showChargeDetails
                  ? "Charge Details"
                  : showCompletedCharges
                    ? "Completed Charges"
                    : showIncompleteCharges
                      ? "Upcoming Charges"
                      : showTeleconsultCharges
                        ? "Tele-consult Charges"
                        : !!packageId
                          ? "Package Transactions"
                          : isShowPackages
                            ? "Manage Packages"
                            : "Homage Wallet"}
              </span>
            ) : (
              <Div>
                <Txt b>Package Details</Txt>
                <Txt color="#9191A2" fs={12}>
                  ID: {packageDetail.purchased_id}
                </Txt>
              </Div>
            )}
            {isConcierge &&
              !showChargeDetails &&
              !showCompletedCharges &&
              !showIncompleteCharges &&
              !showTeleconsultCharges &&
              !!!packageDetail &&
              !!!packageId &&
              !isShowPackages && <div className="concierge-tag">CONCIERGE</div>}
          </div>
          <div className="wa-h-30">
            <IconButton
              className="wa-dialog-close"
              onClick={onCloseDialog}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </div>
        </div>
        <div className="wa-line" />
        {!showChargeDetails &&
          !showCompletedCharges &&
          !showIncompleteCharges &&
          !showTeleconsultCharges &&
          !!!packageDetail &&
          !!!packageId &&
          !isShowPackages && (
            <>
              {addCard && (
                <div className="wa-pkg-padding">
                  <span className="wa-setup-card-txt">
                    Please setup the card
                  </span>
                  <div id="stripe2" className="flex justified">
                    <Elements stripe={stripePromise}>
                      <CheckoutForm2
                        onSubmit2={(res: any) =>
                          res && res.token && AddCardApi(res)
                        }
                      />
                    </Elements>
                  </div>
                </div>
              )}

              {!addCard && (
                <div className="wa-wallet-height">
                  <Div className="wa-pkg-padding wa-tl-height" bg="#32BDC7">
                    <div className="flex justify-between">
                      <div className="wa-visa-div">
                        <div
                          style={{ height: 56, alignItems: "center" }}
                          className="flex justify-between"
                        >
                          <div className="flex vc">
                            {!isConcierge && (
                              <>
                                <img
                                  alt=""
                                  height={18}
                                  src={
                                    cardInfo.icon || "/self-serve/card@3x.png"
                                  }
                                />
                                {cardNumber ? (
                                  <span className="wa-ending-with">
                                    Ending with <b>{cardNumber}</b>
                                  </span>
                                ) : (
                                  <Div
                                    className="wa-ending-with"
                                    color="#82838F"
                                  >
                                    No added card yet
                                  </Div>
                                )}
                              </>
                            )}

                            {isConcierge && (
                              <>
                                <Div bg="#32bdc7" ph={7} pv={2} br={2} h hc vc>
                                  <Img
                                    width={20}
                                    src="/homage_logo_white.png"
                                  />
                                </Div>
                                <span className="wa-ending-with">
                                  Homage Credit Card
                                </span>
                              </>
                            )}
                          </div>
                          {cardNumber ? (
                            <Div color="#32BDC7" fs={14} pointer
                              onClick={() => {
                                setCardInfo({ number: '', icon: '' });
                                setAddCard(true);
                              }}>
                              Update
                            </Div>
                          ) : (
                            <Div
                              color="#32BDC7"
                              fs={14}
                              pointer
                              onClick={() => {
                                setAddCard(true);
                              }}
                            >
                              Add
                            </Div>
                          )}
                        </div>
                      </div>
                    </div>
                    {/*  // */}
                    <Div className="flex justify-between" mt={16}>
                      <div className="wa-visa-div">
                        <div
                          style={{ height: 56, alignItems: "center" }}
                          className="flex justify-between"
                        >
                          <div className="flex vc">
                            <img
                              alt=""
                              height={22}
                              width={28}
                              src="/self-serve/Group@3x.png"
                            />
                            {wallet?.active_packages ? (
                              <span className="wa-ending-with">
                                You have{" "}
                                <b>{wallet?.active_packages} packages</b>
                              </span>
                            ) : wallet?.expired_packages ? (
                              <Div className="wa-ending-with" color="#82838F">
                                You have no active package
                              </Div>
                            ) : (
                              <Div className="wa-ending-with" color="#82838F">
                                No packages yet
                              </Div>
                            )}
                          </div>
                          {wallet?.packages?.length > 0 && (
                            <Div
                              color="#32BDC7"
                              fs={14}
                              pointer
                              onClick={handleManagePackage}
                            >
                              Manage
                            </Div>
                          )}
                        </div>
                      </div>
                    </Div>
                  </Div>

                  {isShowTransactions && (
                    <Transactions
                      setShowChargeDetails={setShowChargeDetails}
                      setShowCompletedCharges={setShowCompletedCharges}
                      setShowIncompleteCharges={setShowIncompleteCharges}
                      setShowTeleconsultCharges={setShowTeleconsultCharges}
                      completed_charges={getSectionedData(completed_charges)}
                      upcoming_charges={getSectionedData(upcoming_charges)}
                      teleconsult_charges={getSectionedData(
                        teleconsult_charges
                      )}
                    />
                  )}
                </div>
              )}
            </>
          )}
        {isShowPackages && !!!packageDetail && (
          <ManagePackages
            walletPackages={walletPackages}
            setPackageDetail={setPackageDetail}
          />
        )}
        {!!packageDetail && !!!packageId && (
          <PackageDetail
            packageDetail={packageDetail}
            setPackageId={setPackageId}
          />
        )}
        {!!packageId && <PackageTransactions packageId={packageId} />}
        {showCompletedCharges && !showChargeDetails && (
          <Div className="wa-pkg-padding show-full-log" mt={5}>
            {completeChargeDataKeys.map((date: string) => (
              <Div>
                <Txt fs={14} color="#A4A4A4" mt={35} className="charge-date">
                  {date}
                </Txt>
                <Div mt={10}>
                  {getSectionedData(completed_charges)
                    .filter((ele: any) => ele.charge_date === date)
                    .map((log: any) => (
                      <ChargeItem
                        itemArray={log.items}
                        setShowChargeDetails={setShowChargeDetails}
                      />
                    ))}
                </Div>
              </Div>
            ))}
          </Div>
        )}
        {showTeleconsultCharges && !showChargeDetails && (
          <Div className="wa-pkg-padding show-full-log" mt={5}>
            {teleconsultChargeDataKeys.map((date: string) => (
              <Div>
                <Txt fs={14} color="#A4A4A4" mt={35} className="charge-date">
                  {date}
                </Txt>
                <Div mt={10}>
                  {getSectionedData(teleconsult_charges)
                    .filter((ele: any) => ele.charge_date === date)
                    .map((log: any) => (
                      <ChargeItem
                        itemArray={log.items}
                        setShowChargeDetails={setShowChargeDetails}
                      />
                    ))}
                </Div>
              </Div>
            ))}
          </Div>
        )}
        {showIncompleteCharges && !showChargeDetails && (
          <Div className="wa-pkg-padding show-full-log">
            <Div
              className="flex center"
              color=" #A4A4A4"
              fs={12}
              bg="rgb(236, 236, 236,0.57)"
              p={10}
              br={4}
            >
              <Img size={13} src="/self-serve/time@3x.png" pl={13} />
              <Txt>
                The charge amount may change if there are additional services or
                adjustments done on the visit.
              </Txt>
            </Div>
            {upcomingChargeDataKeys.map((date: string) => (
              <Div>
                <Txt fs={14} color="#A4A4A4" mt={35} className="charge-date">
                  {`Charge by ${date}`}
                </Txt>
                <Div mt={10}>
                  {getSectionedData(upcoming_charges)
                    .filter((ele: any) => ele.charge_date === date)
                    .map((log: any) => (
                      <ChargeItem
                        itemArray={log.items}
                        setShowChargeDetails={setShowChargeDetails}
                      />
                    ))}
                </Div>
              </Div>
            ))}
          </Div>
        )}
        {showChargeDetails && (
          <Div className="wa-pkg-padding">
            <ChargeDetails chargeDetails={showChargeDetails} />
          </Div>
        )}
      </div>
    </PortalDialog>
  );
};
export default Wallet;
